import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TermsComponent } from './terms.component';
import { SectionTextModule } from 'src/app/shared/section-text/section-text.module';
import { SectionHeaderGapModule } from 'src/app/shared/section-header-gap/section-header-gap.module';
import { SectionFooterBannerModule } from 'src/app/shared/section-footer-banner/section-footer-banner.module';

@NgModule({
  declarations: [TermsComponent],
  imports: [
    CommonModule,
    SectionHeaderGapModule,
    SectionTextModule,
    SectionFooterBannerModule,
  ],
})
export class TermsModule {}
